import React from 'react'
export default function ContactAdminModal({ isOpen, onClose, product, user }) {
    const [message, setMessage] = React.useState('');
    const [isSending, setIsSending] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [success, setSuccess] = React.useState(null);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSending(true);
        setError(null);
        setSuccess(null);

        try {
            const payload = {
                userName: user.name,
                userEmail: user.email,
                productId: product.id,
                productName: product.name,
                message: message,
            };

            const response = await fetch('/api/contact_admin.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || 'An unknown error occurred.');
            }

            setSuccess(result.message);
            setMessage(''); // Clear message on success
            setTimeout(() => {
                onClose();
                setSuccess(null); // Reset for next time
            }, 3000); // Close modal after 3 seconds

        } catch (err) {
            setError(err.message);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl p-8 max-w-lg w-full">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-gray-900">Contact Admin</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <i className="fas fa-times text-xl"></i>
                    </button>
                </div>

                {error && <div className="bg-red-100 text-red-700 p-3 rounded-lg text-sm mb-4">{error}</div>}
                {success && <div className="bg-green-100 text-green-700 p-3 rounded-lg text-sm mb-4">{success}</div>}

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Regarding Product</label>
                        <input type="text" disabled value={`${product.name} (ID: ${product.id})`} className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-100" />
                    </div>
                    <div>
                        <label htmlFor="message" className="block text-sm font-medium text-gray-700">Your Message</label>
                        <textarea id="message" name="message" rows="5" required value={message} onChange={(e) => setMessage(e.target.value)} className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500" placeholder="Please type your question or inquiry here..."></textarea>
                    </div>
                    <div className="flex justify-end">
                        <button type="submit" disabled={isSending} className="primary-gradient text-white py-2 px-6 rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50">
                            {isSending ? (<><i className="fas fa-spinner fa-spin mr-2"></i>Sending...</>) : (<><i className="fas fa-paper-plane mr-2"></i>Send Message</>)}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

